<template>
    <div class="addCard">
        <div class="mobile-text">
            <div class="addCard-title">Teach:able</div>
            <div class="addCard-part">
                <p>
                    <img src="../assets/img/mobile/billings-icon.png">
                    <span @click="this.$router.push('/user/billing')">Billings</span>&ensp;>>&ensp;Add Credit Card
                </p>
            </div>
        </div>
        <div class="addCard-box">
            <div class="text">
                <div class="back" @click="this.$router.push('/user/billing')">
                    &lt;&lt; Back
                </div>
                <div class="title">
                    Add Credit Card
                </div>
                <div class="detail">
                    This card will be available to use for courses enrollments on school.
                </div>
            </div>
            <div class="form">
                <el-form v-model="form" @change="checkValid()">
                    <div class="form-item">
                        <div class="title">Card Number</div>
                        <div class="input"><el-input  v-mask="'#### #### #### ####'" v-model="form.bank_no" placeholder="1234 1234 1234 1234"/></div>
                    </div>
                    <div class="form-item medium left">
                        <div class="title">Expiration</div>
                        <div class="input expired"><el-input v-mask="'##/##'" v-model="form.expired" placeholder="MM/YY" /></div>
                    </div>
                    <div class="form-item medium">
                        <div class="title">CVC Code</div>
                        <div class="input"><el-input v-mask="'###'" v-model="form.cvc" placeholder="CVC"/></div>
                    </div>
                    <div class="form-item medium left">
                        <div class="title">Country</div>
                        <div class="input">
                            <el-select v-model="form.country" placeholder="Select">
                                <el-option
                                    v-for="item in countries"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form-item medium">
                        <div class="title">Zip Code</div>
                        <div class="input"><el-input v-model="form.code" placeholder="99100"/></div>
                    </div>
                    <div class="button medium" :class="{'valid': isActive}" @click="addCard()">
                        <el-button>Add Card</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'AddCard',
        data() {
            return {
                isActive: false,
                countries: [],
                form:{
                    bank_no: '',
                    expired: '',
                    cvc: '',
                    country: '',
                    code: '',
                },
            }
        },
        mounted () {
            this.getCountryList();
        },
        methods: {
            checkValid() {
                var valid = true;
                for (var key in this.form) {
                   if (!this.form[key]) {
                        valid = false;
                   }
                }
                if (valid) {
                    this.isActive = true;
                }
            },
            translate(string) {
                switch (string) {
                    case 'bank_no':
                        return 'Card Number';
                    case 'expired':
                        return 'Card Expired Date';
                    case 'CVC':
                        return 'Card CVC';
                    case 'country':
                        return 'Country';
                    case 'code':
                        return 'Zip Code';
                    default:
                        return string;
                }
            },
            getCountryList() {
                 this.$api.request('System/countries').then((result) => {
                    if (result.status == true) {
                       this.countries = result.data;
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.$message.error(error.msg);
                });
            },
            addCard() {
               for (var key in this.form) {
                   if (!this.form[key]) {
                        this.$message.error(`${this.translate(key)} cannot be empty`);
                        return;
                   }
                }
                this.form.bank_no = this.form.bank_no.replaceAll(" ", "");
                console.log(this.form);
                
                 this.$api.request('UserBank/add', this.form).then((result) => {
                    if (result.status == true) {
                        this.$message.success('New Card Added');
                        this.$router.push({path: "/user/billing"});
                      
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    
                    this.$message.error(error.msg);
                });
            },
        },
    }
</script>

<style lang='scss' type='text/css'>
    @import "../styles/pc/AddCard.scss";
    @import "../styles/mobile/AddCard.scss";
</style>
